(() => {
  if (window.unfoldPdpInit) return;
  window.unfoldPdpInit = true;

  const step = (track) => {
    const cards = track.children;
    return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
  };

  document.addEventListener('scroll', (e) => {
    const track = e.target;
    if (!(track instanceof Element) || !track.classList.contains('unfold-offers__track')) return;
    const root = track.closest('[data-unfold-offers]');
    const i = Math.round(track.scrollLeft / step(track));
    root.querySelectorAll('.unfold-offers__dot').forEach((d, j) => d.classList.toggle('is-active', i === j));
  }, { capture: true, passive: true });

  const placeKf = () => {
    const kf = document.querySelector('.unfold-kf');
    const offers = document.querySelector('.unfold-offers');
    if (!kf || !offers) return;
    if (!kf._home) {
      kf._home = document.createComment('unfold-kf');
      kf.before(kf._home);
    }
    const head = kf.querySelector('.unfold-kf__head');
    if (mq.matches) {
      if (offers.nextElementSibling !== kf) offers.after(kf);
      if (!kf.classList.contains('unfold-kf--inline')) {
        kf.classList.add('unfold-kf--inline');
        kf.classList.remove('is-collapsed');
        head.setAttribute('role', 'button');
        head.setAttribute('tabindex', '0');
        head.setAttribute('aria-expanded', 'true');
      }
    } else if (kf.classList.contains('unfold-kf--inline')) {
      kf._home.after(kf);
      kf.classList.remove('unfold-kf--inline', 'is-collapsed');
      ['role', 'tabindex', 'aria-expanded'].forEach((a) => head.removeAttribute(a));
    }
  };
  const toggleKf = (head) => {
    const kf = head.closest('.unfold-kf--inline');
    if (!kf) return false;
    const collapsed = kf.classList.toggle('is-collapsed');
    head.setAttribute('aria-expanded', String(!collapsed));
    return true;
  };
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const head = e.target.closest && e.target.closest('.unfold-kf--inline .unfold-kf__head');
    if (head && e.target === head && toggleKf(head)) e.preventDefault();
  });
  const mq = window.matchMedia('(max-width: 76700px)');
  mq.addEventListener('change', placeKf);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeKf);
  else placeKf();

  const copyText = (text) => {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.cssText = 'position:fixed;opacity:0;top:0;left:0';
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    ta.remove();
    return Promise.resolve();
  };

  document.addEventListener('click', (e) => {
    const kfHead = e.target.closest('.unfold-kf--inline .unfold-kf__head');
    if (kfHead && !e.target.closest('.unfold-kf__nav')) {
      toggleKf(kfHead);
      return;
    }
    const dot = e.target.closest('.unfold-offers__dot');
    if (dot) {
      const root = dot.closest('[data-unfold-offers]');
      const track = root.querySelector('.unfold-offers__track');
      const i = [...root.querySelectorAll('.unfold-offers__dot')].indexOf(dot);
      track.scrollTo({ left: i * step(track), behavior: 'smooth' });
      return;
    }
    const btn = e.target.closest('.unfold-coupon__copy');
    if (!btn) return;
    const label = btn.querySelector('[data-copy-label]');
    copyText(btn.dataset.code).then(() => {
      btn.classList.add('is-copied');
      label.textContent = 'Copied!';
      clearTimeout(btn._t);
      btn._t = setTimeout(() => {
        btn.classList.remove('is-copied');
        label.textContent = 'Copy';
      }, 1800);
    });
  });
})();

(() => {
  if (window.unfoldPdpRhythm) return;
  window.unfoldPdpRhythm = true;
  const init = () => {
    const main = document.getElementById('MainContent');
    if (!main || !document.querySelector('.unfold-offers, .unfold-trust, .unfold-acc')) return;
    main.classList.add('unfold-pdp-rhythm');
    const sections = [...main.children].filter((s) => s.classList.contains('shopify-section'));
    const mark = () => {
      let first = true;
      sections.forEach((s) => {
        const empty = s.getBoundingClientRect().height < 2;
        s.classList.toggle('unfold-empty', empty);
        s.classList.toggle('unfold-first', !empty && first);
        if (!empty) first = false;
      });
    };
    const ro = new ResizeObserver(mark);
    sections.forEach((s) => ro.observe(s));
    mark();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
